import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["size", "orientation"];
import React, { useContext } from 'react';
import { ThemeContext, mediaForObjectSyntax, styled } from '../../../styled-components';
import { Box } from '../box';
export const Stack = _ref => {
  let {
      size,
      orientation = 'vertical'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(StyledStack, _extends({
    theme: theme,
    size: size,
    orientation: orientation
  }, rest));
};
const getMarginValue = (props, index) => {
  var _props$theme;
  return props.size && props.size[index] ? `${(_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.spacings[props.size[index]]} !important` : '0';
};
const StyledStack = styled(Box)(props => {
  return {
    display: props.orientation === 'horizontal' ? 'flex' : undefined,
    '> * + *': {
      marginTop: props.orientation === 'vertical' ? getMarginValue(props, 0) : undefined,
      marginLeft: props.orientation === 'horizontal' ? getMarginValue(props, 0) : undefined
    },
    [mediaForObjectSyntax.tabletAndUp]: {
      '> * + *': {
        marginTop: props.orientation === 'vertical' ? getMarginValue(props, 1) : undefined,
        marginLeft: props.orientation === 'horizontal' ? getMarginValue(props, 1) : undefined
      }
    },
    [mediaForObjectSyntax.tabletWideAndUp]: {
      '> * + *': {
        marginTop: props.orientation === 'vertical' ? getMarginValue(props, 2) : undefined,
        marginLeft: props.orientation === 'horizontal' ? getMarginValue(props, 2) : undefined
      }
    },
    [mediaForObjectSyntax.desktopAndUp]: {
      '> * + *': {
        marginTop: props.orientation === 'vertical' ? getMarginValue(props, 3) : undefined,
        marginLeft: props.orientation === 'horizontal' ? getMarginValue(props, 3) : undefined
      }
    },
    [mediaForObjectSyntax.largeDesktop]: {
      '> * + *': {
        marginTop: props.orientation === 'vertical' ? getMarginValue(props, 4) : undefined,
        marginLeft: props.orientation === 'horizontal' ? getMarginValue(props, 4) : undefined
      }
    }
  };
});